import React from "react";
import {css, Theme} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";

import {cellWidth, cellWidthMd, cellWidthPrint, cellWidthSm, cellWidthXl} from "../../styles/table_cell_styles";
import {IComparisonTableCell} from "../../types/IComparisonTableCell";
import {DefaultCellRenderer} from "./renderer/DefaultCellRenderer";

interface IProps<TTableItemData> {
    height: number;
    item: TTableItemData;
    value?: TTableItemData[keyof TTableItemData] | null;
    cellComponent?: IComparisonTableCell<TTableItemData>;
    isDisabled?: boolean;
    className?: string;
}

export const Cell = <TTableItemData,>(props: IProps<TTableItemData>) => {
    const CellComponent = props.cellComponent;
    const value = props.value;

    return (
        <Text as="div" style={{minHeight: props.height || "auto"}} css={[dataCellStyle, props.isDisabled && disabledCellStyle]} className={props.className}>
            {CellComponent ? <CellComponent item={props.item} value={value} /> : <DefaultCellRenderer value={value} />}
        </Text>
    );
};

const dataCellStyle = (theme: Theme) => css`
    position: relative;
    display: inline-flex;
    align-items: center;
    overflow-wrap: break-word;
    word-break: break-word;
    ${p(2, 1.5)};
    // Match the visual height of one-line rows when cell content is missing.
    &:empty {
        min-height: 5.2rem;
    }
    user-select: none;
    ${cellWidthSm};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${cellWidthMd};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${cellWidthXl};
    }

    @media (min-width: ${theme.breakpoints.xl}) {
        ${cellWidth};
    }

    @media print {
        ${cellWidthPrint};
    }
`;

const disabledCellStyle = css`
    opacity: 0.5;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {p} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";

import {cellWidth, cellWidthMd, cellWidthPrint, cellWidthSm, cellWidthXl} from "../../styles/table_cell_styles";
import {IComparisonTableCell} from "../../types/IComparisonTableCell";
import {DefaultCellRenderer} from "./renderer/DefaultCellRenderer";

interface IProps<TTableItemData> {
    height: number;
    item: TTableItemData;
    value?: TTableItemData[keyof TTableItemData] | null;
    cellComponent?: IComparisonTableCell<TTableItemData>;
    isDisabled?: boolean;
    className?: string;
}

export const Cell = <TTableItemData,>(props: IProps<TTableItemData>) => {
    const CellComponent = props.cellComponent;
    const value = props.value;

    return (
        <Text as="div" style={{minHeight: props.height || "auto"}} css={[dataCellStyle, props.isDisabled && disabledCellStyle]} className={props.className}>
            {CellComponent ? <CellComponent item={props.item} value={value} /> : <DefaultCellRenderer value={value} />}
        </Text>
    );
};

const dataCellStyle = (theme: Theme) => css`
    position: relative;
    display: inline-flex;
    align-items: center;
    overflow-wrap: break-word;
    word-break: break-word;
    ${p(2, 1.5)};
    // Match the visual height of one-line rows when cell content is missing.
    &:empty {
        min-height: 5.2rem;
    }
    user-select: none;
    ${cellWidthSm};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${cellWidthMd};
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${cellWidthXl};
    }

    @media (min-width: ${theme.breakpoints.xl}) {
        ${cellWidth};
    }

    @media print {
        ${cellWidthPrint};
    }
`;

const disabledCellStyle = css`
    opacity: 0.5;
`;
